import React, { useState, useEffect, useContext } from 'react';
import { Checkbox } from 'quantux-ui';
import CaseScheduleContext from './case-schedule-context';

const BELL_ICON = (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 7.439v4.376l2 1.75v.875H9.988C9.878 15.314 9.026 16 8 16c-1.036 0-1.88-.686-1.988-1.56H0v-.875l2-1.75V7.439c0-2.696 1.63-4.936 4.5-5.531v-.595C6.5.586 7.17 0 8 0s1.5.586 1.5 1.313v.595c2.86.595 4.5 2.844 4.5 5.53Z"
      fill="#FF6060"
    />
  </svg>
);

const SUCCESS_ICON = (
  <svg
    width="12"
    height="12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6a6 6 0 1 1 12 0A6 6 0 1 1 0 6Zm2.646-.238 1.896 1.796L9.36 3l.641.608-5.458 5.17L2 6.369l.646-.607Z"
      fill="#00B080"
    />
  </svg>
);

const Selfpay = (props) => {
  const [isNone, setIsNone] = useState(false);

  let readOnlyMode = false;
  const context = useContext(CaseScheduleContext);
  if (context) {
    readOnlyMode = context.readOnlyMode;
  }

  useEffect(() => {
    setIsNone(props.isNone)
  }, [props.isNone]);

  const handleOnChangeIsNone = () => {
    props.onChangeIsNone(!isNone);
    // if (!readOnlyMode) {
    //   props.onChangeIsNone(!isNone);
    // }
  };

  return (
    <div
      style={{
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <div className='fx fx__v-center'>
        {!isNone ? BELL_ICON : SUCCESS_ICON}
        &nbsp;&nbsp; Self Pay
      </div>
      <Checkbox
        text='None'
        isChecked={isNone}
        onChange={handleOnChangeIsNone}
      />
    </div>
  );
};

export default Selfpay;
